import { Injectable } from '@angular/core';
import { Contact } from 'src/app/model/contacts/contact';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class ContactTableService extends BaseTableService<Contact> {
  private embedded = false;

  constructor() {
    super();
  }

  isScreenEmbedded(): boolean {
    return this.embedded;
  }

  setScreenEmbedded(embedded: boolean): void {
    this.embedded = embedded;
  }
}
